import { fetchPopupNotification, deletePopupNotification } from 'Features/Learning/PopupNotification/Utils/PopupNotificationUtils';
import { handleDeleteConfirmation } from 'Utils/handleDelete';

/* **************************************************** */
/* CRUD PopupNotification                                       */
/* **************************************************** */

export const fetchPopupNotifications = (dispatch, filters, refatch) => {
  dispatch(fetchPopupNotification(filters));
};

export const handleDeletePopupNotification = async (dispatch, id, setRefetch) => {
  handleDeleteConfirmation({
    dispatch,
    id,
    setRefetch,
    deleteAction: deletePopupNotification,
  });
};

export const handleEditPopupNotification = async (dispatch, item, setField, toggle) => {
  dispatch(setField({ field: 'image', value: item?.image }));
  dispatch(setField({ field: 'url', value: item?.url }));
  dispatch(setField({ field: 'target_page', value: item?.target_page }));
  dispatch(setField({ field: 'is_show', value: item?.is_show }));
  dispatch(setField({ field: 'isUpdate', value: true }));
  dispatch(setField({ field: 'id', value: item?.id }));
  toggle();
};

/* **************************************************** */
/* Pagination                                           */
/* **************************************************** */

export const handleBackPagination = (pagination, filters, dispatch, setFilters, setRefetch) => {
  if (pagination.current_page > 1) {
    dispatch(setFilters({
      ...filters,
      page: pagination.current_page - 1
    }));
    setRefetch(prevRefetch => !prevRefetch);
  }
}

export const handleNextPagination = (pagination, filters, dispatch, setFilters, setRefetch) => {
  if (pagination.current_page < pagination.last_page) {
    dispatch(setFilters({
      ...filters,
      page: pagination.current_page + 1
    }));
    setRefetch(prevRefetch => !prevRefetch);
  }
}

export const handleClickPagination = (page, filters, dispatch, setFilters, setRefetch) => {
  console.log(page);
  dispatch(setFilters({
    ...filters,
    page: page
  }));
  setRefetch(prevRefetch => !prevRefetch);
}